export default {
  snap: {
    container:
      "w-full flex flex-col",
    item: "bg-paper grad_border_1 rounded-2xl px-4 md:px-10 py-4 md:py-6 mb-4",
    question:
      "w-full max-w-w2_xl flex justify-between items-center]",
    question_text:
      "text-[18px] md:text-[20px] lg:text-[22px] xl:text-[24px] text-left text-text_secondary font-normal hover:text-primary leading-[24px] md:leading-[28px] lg:leading-[30px] xl:leading-[32px]",
    question_text_selected:
      "text-[18px] md:text-[20px] lg:text-[24px] text-left text-primary font-semibold leading-[24px] md:leading-[28px] lg:leading-[32px]",
    toggle: "text-primary text-[26px] font-light",
    motion_container: "w-full overflow-hidden",
    answer:
      "w-full text-text text-[16px] leading-normal font-normal pr-6 md:pr-10 mt-6 mb-0",
  },

  // Smaller question-text font-height, smaller container-height
  snap_compact: {
    container:
      "w-full flex flex-col",
    item: "bg-paper grad_border_1 rounded-2xl px-4 md:px-10 py-4 md:py-5 mb-4",
    question:
      "w-full max-w-w2_xl flex justify-between items-center]",
    question_text:
      "text-[16px] md:text-[17px] lg:text-[20px] text-left text-text_secondary font-normal hover:text-primary leading-[24px] md:leading-[28px] lg:leading-[30px] xl:leading-[32px]",
    question_text_selected:
      "text-[16px] md:text-[17px] lg:text-[20px] text-left text-primary font-semibold leading-[24px] md:leading-[28px] lg:leading-[32px]",
    toggle: "text-primary text-[26px] font-light",
    motion_container: "w-full overflow-hidden",
    answer:
      "w-full text-text text-[16px] leading-normal font-normal pr-6 md:pr-10 mt-6 mb-0",
  },
}
